const { createConstant } = require('../helpers')

// Check address, this might change
const service = 'case-service'

module.exports = {
  POST_CHAT_DATA: createConstant(service, 'POST_CHAT_DATA'),
  POST_CHAT_DATA_SUCCESS: createConstant(service, 'POST_CHAT_DATA_SUCCESS'),
  POST_CHAT_DATA_ERROR: createConstant(service, 'POST_CHAT_DATA_ERROR'),
  POST_CHAT_DATA_RESET: createConstant(service, 'POST_CHAT_DATA_RESET'),

  GET_CHAT_DATA: createConstant(service, 'GET_CHAT_DATA'),
  GET_CHAT_DATA_SUCCESS: createConstant(service, 'GET_CHAT_DATA_SUCCESS'),
  GET_CHAT_DATA_ERROR: createConstant(service, 'GET_CHAT_DATA_ERROR'),
  GET_CHAT_DATA_RESET: createConstant(service, 'GET_CHAT_DATA_RESET'),
}
